import { render, staticRenderFns } from "./TranslateSelect.vue?vue&type=template&id=8c33749e&scoped=true"
import script from "./TranslateSelect.vue?vue&type=script&lang=js"
export * from "./TranslateSelect.vue?vue&type=script&lang=js"
import style0 from "./TranslateSelect.vue?vue&type=style&index=0&id=8c33749e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c33749e",
  null
  
)

export default component.exports